export class DPNUser {
  public userId: string;
  public firstName: string;
  public lastName: string;
  public emailAddress: string;
  public office: string;
  public defaultMemberFirmName: string;
  public showCustomerSurvey: boolean;

  constructor(data) {
    Object.assign(this, data);
  }

  get fullName(): string {
    return `${this.lastName ? this.lastName : ''}${this.firstName && this.lastName ? ', ' : ''}${
      this.firstName ? this.firstName : ''
    }`;
  }

  get username(): string {
    return this.emailAddress?.slice(0, this.emailAddress.indexOf('@'));
  }
}

export class User extends DPNUser {
  public isSystem: boolean;
  public active: boolean;
  public createdAt: Date;
  public createdBy: string;
  public lastUpdateAt: Date;
  public lastUpdateBy: string;
}
